/* Aurora customizer: CD and CD cover side by side, with printable and unprintable areas marked.
   Disc and cover are drawn at the same scale (both are the same width). Ratios only: no measurements are claimed. */
(function () {
  'use strict';
  var L = window.AuroraCZ;

  var R = 210;                                   // disc radius in canvas px
  var DISC = { cx: 770, cy: 300 };
  var COVER = { x: 50, y: 90, w: 420, h: 420 };
  // as fractions of the disc radius
  var HOLE = 0.125, HUB = 0.25, RIM = 0.976;

  function hatchPx(c, path, rule) {
    c.save();
    c.clip(path, rule || 'nonzero');
    c.strokeStyle = 'rgba(194,64,47,0.62)'; c.lineWidth = 1.2;
    c.beginPath();
    for (var t = -700; t < 1500; t += 8) { c.moveTo(t, 0); c.lineTo(t - 700, 700); }
    c.stroke();
    c.restore();
  }
  function ring(cx, cy, rOut, rIn) {
    var p = new Path2D();
    p.arc(cx, cy, rOut, 0, Math.PI * 2);
    p.arc(cx, cy, rIn, 0, Math.PI * 2, true);
    return p;
  }

  function init(root) {
    var t = L.i18n(root);
    var canvas = root.querySelector('[data-cz-canvas]');
    var ctx = canvas.getContext('2d');
    var empty = root.querySelector('[data-cz-empty]');
    var status = root.querySelector('[data-cz-status]');
    var hint = root.querySelector('[data-cz-hint]');
    var dlBtn = root.querySelector('[data-cz-download]');
    var mailLink = root.querySelector('[data-cz-mail]');
    var legend = root.querySelector('[data-cz-legend]');
    var mail = root.getAttribute('data-mail') || '';

    var st = { sel: 'disc', base: '#d5d9d8', showZones: true,
      side: { disc: { pic: null, pl: new L.Placement('cover') }, cover: { pic: null, pl: new L.Placement('cover') } } };
    function say(m, k) { L.say(status, m, k); }

    function paintDisc(c, opts) {
      var cx = DISC.cx, cy = DISC.cy;
      var s = st.side.disc;
      c.save();
      if (opts.shadow) { c.shadowColor = 'rgba(15,32,25,0.25)'; c.shadowBlur = 30; c.shadowOffsetY = 14; }
      c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.fillStyle = st.base; c.fill();
      c.restore();

      if (s.pic) {
        c.save();
        c.beginPath(); c.arc(cx, cy, R * RIM, 0, Math.PI * 2); c.arc(cx, cy, R * HUB, 0, Math.PI * 2, true); c.clip();
        L.drawPic(c, s.pic, s.pl, { x: cx - R, y: cy - R, w: 2 * R, h: 2 * R });
        c.restore();
      } else if (opts.shadow) {
        c.save(); c.fillStyle = 'rgba(20,32,26,0.55)';
        c.font = '600 30px "Noto Sans TC","PingFang TC","Microsoft JhengHei",sans-serif';
        c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText(t.sideDisc, cx, cy + R * 0.55);
        c.restore();
      }

      // the clear hub ring, then the hole itself
      c.save();
      c.beginPath(); c.arc(cx, cy, R * HUB, 0, Math.PI * 2); c.fillStyle = 'rgba(255,255,255,0.45)'; c.fill();
      c.lineWidth = 1; c.strokeStyle = 'rgba(15,32,25,0.2)'; c.stroke();
      c.globalCompositeOperation = 'destination-out';
      c.beginPath(); c.arc(cx, cy, R * HOLE, 0, Math.PI * 2); c.fill();
      c.restore();

      // a faint sheen like a real disc
      if (c.createConicGradient) {
        c.save();
        c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.arc(cx, cy, R * HOLE, 0, Math.PI * 2, true); c.clip();
        var g = c.createConicGradient(0.5, cx, cy);
        g.addColorStop(0, 'rgba(255,255,255,0.0)'); g.addColorStop(0.12, 'rgba(255,255,255,0.20)');
        g.addColorStop(0.25, 'rgba(255,255,255,0.0)'); g.addColorStop(0.62, 'rgba(255,255,255,0.0)');
        g.addColorStop(0.74, 'rgba(255,255,255,0.18)'); g.addColorStop(0.86, 'rgba(255,255,255,0.0)');
        c.fillStyle = g; c.fillRect(cx - R, cy - R, 2 * R, 2 * R);
        c.restore();
      }

      if (opts.shadow) {
        c.save();
        c.beginPath(); c.arc(cx, cy, R - 0.75, 0, Math.PI * 2); c.lineWidth = 1.5; c.strokeStyle = 'rgba(15,32,25,0.2)'; c.stroke();
        if (st.showZones) {
          var hub = ring(cx, cy, R * HUB, R * HOLE), edge = ring(cx, cy, R, R * RIM);
          c.fillStyle = 'rgba(194,64,47,0.14)'; c.fill(hub); c.fill(edge);
          hatchPx(c, hub); hatchPx(c, edge);
          var ok = ring(cx, cy, R * RIM, R * HUB);
          c.fillStyle = 'rgba(30,201,192,0.06)'; c.fill(ok);
          c.setLineDash([8, 6]); c.lineWidth = 1.6; c.strokeStyle = 'rgba(14,150,140,0.95)';
          c.beginPath(); c.arc(cx, cy, R * RIM, 0, Math.PI * 2); c.stroke();
          c.beginPath(); c.arc(cx, cy, R * HUB, 0, Math.PI * 2); c.stroke();
        }
        if (st.sel === 'disc') {
          c.setLineDash([]); c.beginPath(); c.arc(cx, cy, R + 8, 0, Math.PI * 2);
          c.lineWidth = 3; c.strokeStyle = 'rgba(30,201,192,0.95)'; c.stroke();
        }
        c.restore();
      }
    }

    function paintCover(c, opts) {
      var r = COVER, s = st.side.cover;
      c.save();
      if (opts.shadow) { c.shadowColor = 'rgba(15,32,25,0.22)'; c.shadowBlur = 30; c.shadowOffsetY = 14; }
      L.rrect(c, r.x, r.y, r.w, r.h, 4); c.fillStyle = '#f6f4ee'; c.fill();
      c.restore();
      if (s.pic) {
        c.save(); L.rrect(c, r.x, r.y, r.w, r.h, 4); c.clip();
        L.drawPic(c, s.pic, s.pl, r);
        c.restore();
      } else if (opts.shadow) {
        c.save(); c.fillStyle = 'rgba(20,32,26,0.55)';
        c.font = '600 30px "Noto Sans TC","PingFang TC","Microsoft JhengHei",sans-serif';
        c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText(t.sideCover, r.x + r.w / 2, r.y + r.h / 2);
        c.restore();
      }
      if (opts.shadow) {
        c.save();
        var m = r.w * 0.03, safe = r.w * 0.06;
        if (st.showZones) {
          var trim = new Path2D(); trim.rect(r.x, r.y, r.w, r.h); trim.rect(r.x + m, r.y + m, r.w - 2 * m, r.h - 2 * m);
          c.fillStyle = 'rgba(214,158,46,0.2)'; c.fill(trim, 'evenodd');
          c.save(); c.clip(trim, 'evenodd'); c.strokeStyle = 'rgba(176,118,20,0.7)'; c.lineWidth = 1.2; c.beginPath();
          for (var t2 = -700; t2 < 1500; t2 += 8) { c.moveTo(t2, 0); c.lineTo(t2 - 700, 700); }
          c.stroke(); c.restore();
          c.setLineDash([8, 6]); c.lineWidth = 1.6; c.strokeStyle = 'rgba(14,150,140,0.95)';
          c.strokeRect(r.x + safe, r.y + safe, r.w - 2 * safe, r.h - 2 * safe);
        }
        L.rrect(c, r.x + 0.75, r.y + 0.75, r.w - 1.5, r.h - 1.5, 4);
        c.setLineDash([]); c.lineWidth = 1.5; c.strokeStyle = 'rgba(15,32,25,0.16)'; c.stroke();
        if (st.sel === 'cover') {
          L.rrect(c, r.x - 8, r.y - 8, r.w + 16, r.h + 16, 10);
          c.lineWidth = 3; c.strokeStyle = 'rgba(30,201,192,0.95)'; c.stroke();
        }
        c.restore();
      }
    }

    var queued = false;
    function draw() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        paintCover(ctx, { shadow: true }); paintDisc(ctx, { shadow: true });
      });
    }

    var ctl = L.controls(root, draw);
    function anyPic() { return st.side.disc.pic || st.side.cover.pic; }
    function refreshUI() {
      var cur = st.side[st.sel];
      ctl.bind(cur.pic ? cur.pl : null);
      root.querySelectorAll('[data-side]').forEach(function (b) {
        var on = b.getAttribute('data-side') === st.sel;
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      dlBtn.disabled = !anyPic(); empty.hidden = !!anyPic(); hint.hidden = !anyPic();
    }
    function updateMail() {
      L.mail(mailLink, mail, t.mailSubject, (t.mailBody || '') + '\n\n' + L.label(root, '[data-base].is-on'));
    }

    root.querySelectorAll('[data-upload]').forEach(function (drop) {
      var key = drop.getAttribute('data-upload');
      L.bindUpload(drop, drop.querySelector('input'), function (file) {
        L.loadFile(file, t, say, function (pic) {
          st.side[key].pic = pic; st.side[key].pl.reset();
          drop.classList.add('is-filled'); drop.querySelector('span').textContent = file.name;
          st.sel = key; refreshUI(); draw();
        });
      });
    });
    root.querySelectorAll('[data-side]').forEach(function (b) {
      b.addEventListener('click', function () { st.sel = b.getAttribute('data-side'); refreshUI(); draw(); });
    });
    var baseBtns = root.querySelectorAll('[data-base]');
    baseBtns.forEach(function (b) { b.addEventListener('click', function () {
      st.base = b.getAttribute('data-base'); L.radio(baseBtns, b); updateMail(); draw(); }); });
    root.querySelectorAll('[data-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-toggle'); st[k] = !st[k];
        b.classList.toggle('is-on', st[k]); b.setAttribute('aria-pressed', st[k] ? 'true' : 'false');
        if (legend) legend.hidden = !st.showZones;
        draw();
      });
    });

    L.dragger(canvas, {
      pick: function (x, y) {
        var onDisc = Math.hypot(x - DISC.cx, y - DISC.cy) <= R;
        var onCover = x >= COVER.x && x <= COVER.x + COVER.w && y >= COVER.y && y <= COVER.y + COVER.h;
        var hit = onDisc ? 'disc' : onCover ? 'cover' : null;
        if (hit && hit !== st.sel) { st.sel = hit; refreshUI(); draw(); }
      },
      current: function () {
        var s = st.side[st.sel]; if (!s.pic) return null;
        return st.sel === 'disc' ? { pl: s.pl, w: 2 * R, h: 2 * R } : { pl: s.pl, w: COVER.w, h: COVER.h };
      },
      onZoom: function () { ctl.refresh(); },
      onChange: draw
    });

    dlBtn.addEventListener('click', function () {
      if (!anyPic()) return;
      var k = 1.5, x0 = COVER.x, y0 = DISC.cy - R, w = (DISC.cx + R) - x0, h = 2 * R;
      var out = document.createElement('canvas');
      out.width = Math.round(w * k); out.height = Math.round(h * k);
      var c = out.getContext('2d'); c.scale(k, k); c.translate(-x0, -y0);
      paintCover(c, { shadow: false }); paintDisc(c, { shadow: false });
      L.download(out, (t.fileName || 'aurora-cd-preview') + '.png');
    });

    refreshUI(); updateMail(); draw();
  }

  L.boot('[data-aurora-cz-cd]', init);
})();
